import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './SideMenu.css';
import { Nav, Navbar, Collapse, Button } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import * as FontAwesome from 'react-icons/fa';

import messages from '../../../locale/messages';
import cx from 'classnames';
import Link from '../../Link';
import { adminLogout } from '../../../actions/siteadmin/logout';
import { connect } from 'react-redux';

// Components
import HeaderModal from '../../HeaderModal/HeaderModal';

// Action
import { openHeaderModal } from '../../../actions/siteadmin/modalActions';

//Images
import DashboardIcon from '../../../../public/Icons/1Dashboard.svg';
import SiteSettingIcon from '../../../../public/Icons/2sitesettings.svg';
import MobileSettingIcon from '../../../../public/Icons/3mobileappsettings.svg';
import DriversIcon from '../../../../public/Icons/8Managedrivers.svg';
import CategoriesIcon from '../../../../public/Icons/10Managedeliverytype.svg';
import BookingsIcon from '../../../../public/Icons/15Manageorders.svg';
import PromoCodeIcon from '../../../../public/Icons/19Managepromocode.svg';
import CompletedBooking from '../../../../public/Icons/16Completedorders.svg';
import ChangePasswordIcon from '../../../../public/Icons/20Changepassword.svg';
import CancalBookingIcon from '../../../../public/Icons/17Failedorders.svg';
import ManageCurrencyIcon from '../../../../public/Icons/22Managecurrency.svg';
import NotificationIcon from '../../../../public/Icons/21Managenotifications.svg';
import LogOutIcon from '../../../../public/Icons/logout.svg';
import MainSiteIcon from '../../../../public/Icons/mainSite.svg';
import HomeSettingIcon from '../../../../public/Icons/5Storesettings.svg';
import RightArrowIcon from '../../../../public/Icons/rightArrowWhite.svg';
import DietaryIcon from '../../../../public/Icons/dietary.svg';
import history from '../../../history';
import serviceFee from '../../../../public/Icons/12Manageservicefee.svg';
import AdminEarningIcon from '../../../../public/Icons/14Adminearnings.svg';
import CancelReason from '../../../../public/Icons/23Cancellationreasons.svg';
import ContentPageManagementIcon from '../../../../public/Icons/25Contentmanagement.svg';
import UserIcon from '../../../../public/Icons/7Manageusers.svg';
import ManageStoresIcon from '../../../../public/Icons/11Managecategory.svg';
import ManageStaticContentIcon from '../../../../public/Icons/24Managestaticcontent.svg';
import ReviewManage from '../../../../public/Icons/18Reviews.svg';
import VehicleType from '../../../../public/Icons/13Vehicletype.svg';
import languageIcon from '../../../../public/Icons/Language-white.svg';
import adminIcon from '../../../../public/Icons/6Manageadmins.svg';
import homeIcon from '../../../../public/Icons/4Homepagesettings.svg';
import helloIcon from '../../../../public/Icons/hello.png';
import deliveryTYpeIcon from '../../../../public/Icons/11Managedeliverytype.svg';
import managePaymentGatewayIcon from '../../../../public/Icons/managePaymentGatewayIcon.svg';
import configIcon from '../../../../public/Icons/siteConfiguration.svg';


// Helper
import { formatLocale } from '../../../helpers/formatLocale';
import { validatePrivilege } from '../../../helpers/adminPrivileges';

class SideMenu extends React.Component {

  static defaultProps = {
    isSuperAdmin: false,
    privileges: []
  };

  constructor(props) {
    super(props);
    this.state = {
      isOpen: 0,
      location: '',
      homepageSettings: false,
      storeHomepageSettings: false,
      profileMenu: false,
      fareAndFees: false
    }
    this.openMenu = this.openMenu.bind(this);
    this.openClose = this.openClose.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    const storeSettingsArray = ['/siteadmin/store-home/banner', '/siteadmin/store-home/info', '/siteadmin/store-home/slider', '/siteadmin/store-home/contact']

    this.setState({
      location: history.location.pathname
    })

    if (history && history.location && storeSettingsArray.includes(history.location.pathname)) {
      this.setState({
        profileMenu: true,
      })
    }

    if (history && history.location
      && (history.location.pathname.startsWith('/siteadmin/manage-service-fee')
        || history.location.pathname.startsWith('/siteadmin/ride-fare'))) {
      this.setState({
        fareAndFees: true,
      })
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { location } = this.props;
    if (prevState.location !== location) {
      this.setState({
        location
      })
    }
  }

  async openMenu() {
    this.setState({
      isOpen: 1,
    })
  }

  async openClose() {
    this.setState({
      isOpen: 0,
    })
  }

  handleChange(e) {
    const { openHeaderModal } = this.props;
    openHeaderModal('languageModal');
  }

  render() {
    const { adminLogout, currentLocale, isSuperAdmin, privileges } = this.props;
    const { location, profileMenu } = this.state;

    let storeSettingsArray = ['/siteadmin/store-home/banner', '/siteadmin/store-home/info', '/siteadmin/store-home/slider', '/siteadmin/store-home/contact']
    let homeSettingsArray = ['/siteadmin/homepage-banner', '/siteadmin/homepage-howitworks', '/siteadmin/homepage-user', '/siteadmin/homepage-category', '/siteadmin/homepage-footersettings', '/siteadmin/homepage-driverApp'];
    let adminManagementArray = ['/siteadmin/admin-users', '/siteadmin/admin-roles'];
    let fareAndFeesArray = ['/siteadmin/manage-service-fee', '/siteadmin/ride-fare'];

    return (
      <div className={s.sideMenuBg}>
        <div className={cx(s.siteAdminHeader, 'siteAdminHeaderRTL')}>
          <span><img src={helloIcon} alt='hello icon' /> <span className={s.welcomeText}><FormattedMessage {...messages.welcomeAdmin} /></span></span>
        </div>
        <div className={cx(s.sideMenuList, 'sideMenu', 'sideMenuScroll')}>
          <div>
            <Link to={''} onClick={() => adminLogout()} className={cx(s.logoutIconMobile, 'd-block', 'logoutIconMobileRTL', 'd-xl-none')}>
              <span className={cx(s.displayInlineBlock, s.vtrTop)}>
                <img src={LogOutIcon} className={cx(s.sideMenuIcon)} alt='logout icon' />
              </span>
            </Link>
          </div>
          <Navbar expand="lg">

            <div className="nav-container">
              <button className={cx("button  d-block d-xl-none")} onClick={() => this.openMenu()} type='button'>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
              </button>
            </div>

            <div className={cx({ [s.menuOpen]: this.state.isOpen === 1 }, s.mobileMenu)}>
              <div className={cx({ [s.menuClose]: this.state.isOpen === 0 }, s.rightMenuClose, 'd-block', 'd-xl-none')}>
                <button type='button' className={cx(s.closeColor, 'closeColorRTL')} onClick={() => this.openClose()} >
                  ×
                </button>
              </div>
              <Nav className="mr-auto">
                <HeaderModal />
                <Link
                  onClick={(e) => this.handleChange(e)}
                  className={cx(s.sideNavitem, s.spaceTop2, s.responsiveDasboradMargin, 'd-block d-sm-block  d-xl-none', 'sideNavitemRTL')} >
                  <span className={cx(s.displayInlineBlock, s.vtrTop, s.languageIcon)}>
                    <img src={languageIcon} className={cx(s.sideMenuIcon, s.noFilter)} alt='language icon' />
                  </span>
                  <span className={cx(s.displayInlineBlock, s.vtrMiddle, s.iconTextPadding)}>
                    {formatLocale(currentLocale)}
                  </span>
                </Link>
                <Link to={'/siteadmin'} className={cx(s.sideNavitem, 'sideNavitemRTL', { [s.activeMenu]: location === '/siteadmin' })} onClick={() => this.openClose()}>
                  <span className={cx(s.displayInlineBlock, s.vtrTop)}>
                    <img src={DashboardIcon} className={cx(s.sideMenuIcon, s.noFilter)} alt='dashboard icon' />
                  </span>
                  <span className={cx(s.displayInlineBlock, s.vtrMiddle)}>
                    <FormattedMessage {...messages.manageDashboard} />
                  </span>
                </Link>

                {/* Booking */}
                {validatePrivilege(12, privileges) && validatePrivilege(13, privileges) && validatePrivilege(14, privileges) &&
                  <span className='text-danger small ml-3'>Booking</span>
                }

                {validatePrivilege(12, privileges) && <Link to={'/siteadmin/bookings'} className={cx(s.sideNavitem, { [s.activeMenu]: location.startsWith('/siteadmin/bookings') || location.startsWith('/siteadmin/view-booking') }, 'sideNavitemRTL')} onClick={() => this.openClose()}>
                  <span className={cx(s.displayInlineBlock, s.vtrTop)}>
                    <img src={BookingsIcon} className={s.sideMenuIcon} alt='booking icon' />
                  </span>
                  <span className={cx(s.displayInlineBlock, s.vtrMiddle)}>
                    <FormattedMessage {...messages.bookingsMenu} />
                  </span>
                </Link>}
                {validatePrivilege(13, privileges) && <Link to={'/siteadmin/completed-bookings'} className={cx(s.sideNavitem, { [s.activeMenu]: location.startsWith('/siteadmin/completed-bookings') }, 'sideNavitemRTL')} onClick={() => this.openClose()}>
                  <span className={cx(s.displayInlineBlock, s.vtrTop)}>
                    <img src={CompletedBooking} className={cx(s.sideMenuIcon, s.noFilter)} alt='complete booking icon' />
                  </span>
                  <span className={cx(s.displayInlineBlock, s.vtrMiddle)}>
                    <FormattedMessage {...messages.manageCompletedTrips} />
                  </span>
                </Link>}
                {validatePrivilege(14, privileges) && <Link to={'/siteadmin/failed-bookings'} className={cx(s.sideNavitem, { [s.activeMenu]: location.startsWith('/siteadmin/failed-bookings') }, 'sideNavitemRTL')} onClick={() => this.openClose()}>
                  <span className={cx(s.displayInlineBlock, s.vtrTop)}>
                    <img src={CancalBookingIcon} className={cx(s.sideMenuIcon, s.noFilter)} alt='cancel booking icon' />
                  </span>
                  <span className={cx(s.displayInlineBlock, s.vtrMiddle)}>
                    <FormattedMessage {...messages.manageCancelledTrips} />
                  </span>
                </Link>}


                {/* User */}
                {validatePrivilege(4, privileges) && validatePrivilege(5, privileges) && validatePrivilege(6, privileges) &&
                  <span className='text-danger small ml-3'>User</span>
                }

                {validatePrivilege(4, privileges) && <Link to={'/siteadmin/users'} className={cx(s.sideNavitem, { [s.activeMenu]: location.startsWith('/siteadmin/users') }, 'sideNavitemRTL')} onClick={() => this.openClose()}>
                  <span className={cx(s.displayInlineBlock, s.vtrTop)}>
                    <img src={UserIcon} className={cx(s.sideMenuIcon, s.noFilter)} alt='user icon' />
                  </span>
                  <span className={cx(s.displayInlineBlock, s.vtrMiddle)}>
                    <FormattedMessage {...messages.usersMenu} />
                  </span>
                </Link>}
                {validatePrivilege(5, privileges) && <Link to={'/siteadmin/drivers'} className={cx(s.sideNavitem, { [s.activeMenu]: location.startsWith('/siteadmin/drivers') }, 'sideNavitemRTL')} onClick={() => this.openClose()}>
                  <span className={cx(s.displayInlineBlock, s.vtrTop)}>
                    <img src={DriversIcon} className={cx(s.sideMenuIcon, s.noFilter)} alt='driver icon' />
                  </span>
                  <span className={cx(s.displayInlineBlock, s.vtrMiddle)}>
                    <FormattedMessage {...messages.driverMenu} />
                  </span>
                </Link>}
                {validatePrivilege(6, privileges) && <Link to={'/siteadmin/store/list'} className={cx(s.sideNavitem, { [s.activeMenu]: location.startsWith('/siteadmin/store/list') || location.startsWith('/siteadmin/store/edit') }, 'sideNavitemRTL')} onClick={() => this.openClose()}>
                  <span className={cx(s.displayInlineBlock, s.vtrTop)}>
                    <img src={ManageStoresIcon} className={cx(s.sideMenuIcon, s.noFilter)} alt='manage store icon' />
                  </span>
                  <span className={cx(s.displayInlineBlock, s.vtrMiddle)}>
                    <FormattedMessage {...messages.manageStores} />
                  </span>
                </Link>}


                {/* Promotion */}
                {validatePrivilege(16, privileges) && validatePrivilege(20, privileges) && validatePrivilege(21, privileges) &&
                  <span className='text-danger small ml-3'>Promotion</span>
                }

                {validatePrivilege(16, privileges) && <Link to={'/siteadmin/promo-code/list'} className={cx(s.sideNavitem, { [s.activeMenu]: location.startsWith('/siteadmin/promo-code') }, 'sideNavitemRTL')} onClick={() => this.openClose()}>
                  <span className={cx(s.displayInlineBlock, s.vtrTop)}>
                    <img src={PromoCodeIcon} className={s.sideMenuIcon} alt='promo code icon' />
                  </span>
                  <span className={cx(s.displayInlineBlock, s.vtrMiddle)}>
                    <FormattedMessage {...messages.managePromoCode} />
                  </span>
                </Link>}

                {validatePrivilege(16, privileges) && <Link to={'/siteadmin/banner'} className={cx(s.sideNavitem, { [s.activeMenu]: location.startsWith('/siteadmin/banner') }, 'sideNavitemRTL')} onClick={() => this.openClose()}>
                  <span className={cx(s.displayInlineBlock, s.vtrTop)}>
                    <img src={configIcon} className={s.sideMenuIcon} alt='config icon' />
                  </span>
                  <span className={cx(s.displayInlineBlock, s.vtrMiddle)}>
                    <FormattedMessage {...messages.manageBanners} />
                  </span>
                </Link>}

                {validatePrivilege(17, privileges) && <Link to={'/siteadmin/notifications'} className={cx(s.sideNavitem, { [s.activeMenu]: location === '/siteadmin/notifications' }, 'sideNavitemRTL')} onClick={() => this.openClose()}>
                  <span className={cx(s.displayInlineBlock, s.vtrTop)}>
                    <img src={NotificationIcon} className={cx(s.sideMenuIcon, s.noFilter)} alt='notification icon' />
                  </span>
                  <span className={cx(s.displayInlineBlock, s.vtrMiddle)}>
                    <FormattedMessage {...messages.manageNotifications} />
                  </span>
                </Link>}

                {validatePrivilege(20, privileges) && <Link to={'/siteadmin/staticpage/manage'} className={cx(s.sideNavitem, { [s.activeMenu]: location.startsWith('/siteadmin/staticpage/manage') || location.startsWith('/siteadmin/staticpage/edit/') }, 'sideNavitemRTL')} onClick={() => this.openClose()}>
                  <span className={cx(s.displayInlineBlock, s.vtrTop)}>
                    <img src={ManageStaticContentIcon} className={cx(s.sideMenuIcon, s.noFilter)} alt='manage static content icon' />
                  </span>
                  <span className={cx(s.displayInlineBlock, s.vtrMiddle)}>
                    <FormattedMessage {...messages.staticpageManagement} />
                  </span>
                </Link>}
                {validatePrivilege(21, privileges) && <Link to={'/siteadmin/contentpage/manage'} className={cx(s.sideNavitem, { [s.activeMenu]: location.startsWith('/siteadmin/contentpage/manage') || location.startsWith('/siteadmin/contentpage/edit/') || location.startsWith('/siteadmin/contentpage/add') }, 'sideNavitemRTL')} onClick={() => this.openClose()}>
                  <span className={cx(s.displayInlineBlock, s.vtrTop)}>
                    <img src={ContentPageManagementIcon} className={cx(s.sideMenuIcon, s.noFilter)} alt='content page icon' />
                  </span>
                  <span className={cx(s.displayInlineBlock, s.vtrMiddle)}>
                    <FormattedMessage {...messages.contentPageManagement} />
                  </span>
                </Link>}


                {/* Configuration */}
                {validatePrivilege(1, privileges) && validatePrivilege(2, privileges) && validatePrivilege(3, privileges) &&
                  <span className='text-danger small ml-3'>Configuration</span>
                }

                {validatePrivilege(1, privileges) && <>
                  <Link to={'/siteadmin/settings/site'} className={cx(s.sideNavitem, { [s.activeMenu]: location === '/siteadmin/settings/site' }, 'sideNavitemRTL')} onClick={() => this.openClose()}>
                    <span className={cx(s.displayInlineBlock, s.vtrTop)}>
                      <img src={SiteSettingIcon} className={cx(s.sideMenuIcon, s.noFilter)} alt='site setting icon' />
                    </span>
                    <span className={cx(s.displayInlineBlock, s.vtrMiddle)}>
                      <FormattedMessage {...messages.siteSettings} />
                    </span>
                  </Link>
                  <Link to={'/siteadmin/settings/mobile'} className={cx(s.sideNavitem, { [s.activeMenu]: location === '/siteadmin/settings/mobile' }, 'sideNavitemRTL')} onClick={() => this.openClose()}>
                    <span className={cx(s.displayInlineBlock, s.vtrTop)}>
                      <img src={MobileSettingIcon} className={cx(s.sideMenuIcon, s.noFilter)} alt='system settings icon' />
                    </span>
                    <span className={cx(s.displayInlineBlock, s.vtrMiddle)}>
                      <FormattedMessage {...messages.systemSettingsPageHeading} />
                    </span>
                  </Link>
                </>
                }
                {validatePrivilege(3, privileges) &&
                  <div>
                    <div id='Homepage'>
                      <Button
                        variant='link'
                        className={cx(s.button, s.noPadding, s.noBorderBtn, s.btnWidth, s.sideNavitem, s.btnNoPadding, { [s.activeInnerMenu]: homeSettingsArray.includes(location) }, 'sideNavitemRTL')}
                        onClick={() => {
                          this.setState({
                            homepageSettings: !this.state.homepageSettings
                          })
                        }
                        }
                      >
                        <span className={cx(s.displayInlineBlock, s.vtrTop, s.mozWidth)}>
                          <img src={homeIcon} className={cx(s.sideMenuIcon, s.noFilter)} alt='home icon' />
                        </span>
                        <span className={cx(s.displayInlineBlock, s.vtrMiddle)}>
                          <FormattedMessage {...messages.HomeSiteSettings} />
                        </span>
                        {
                          this.state.homepageSettings &&
                          <div className={cx(s.displayInlineBlock, s.arrowCss)}>
                            <FontAwesome.FaAngleUp className={s.navigationIcon} />
                          </div>
                        }

                        {
                          !this.state.homepageSettings && <div className={cx(s.displayInlineBlock, s.arrowCss)}><FontAwesome.FaAngleDown className={s.navigationIcon} /></div>
                        }
                      </Button>
                    </div>
                    <Collapse in={this.state.homepageSettings} className={s.subMenu}>
                      <div>
                        <Link to={'/siteadmin/homepage-banner'} className={cx(s.sideNavitem, s.sideNavitemCollapsePadding, { [s.activeMenu]: location === '/siteadmin/homepage-banner' }, 'sideNavitemRTL')} onClick={() => this.openClose()}>
                          <span className={cx(s.displayInlineBlock, s.vtrTop, s.sideNavitemCollapse, 'sideNavitemCollapseTextRTL')}>
                            <img src={RightArrowIcon} className={cx(s.sideMenuIcon, s.sideNavitemCollapseIcon, 'sideNavitemCollapseIconRTL')} alt='right arrow icon' />
                          </span>
                          <span className={cx(s.displayInlineBlock, s.vtrMiddle, s.sideNavitemCollapseText)}>
                            <FormattedMessage {...messages.homeSectionSettings} />
                          </span>
                        </Link>
                        <Link to={'/siteadmin/homepage-howitworks'} className={cx(s.sideNavitem, s.sideNavitemCollapsePadding, { [s.activeMenu]: location === '/siteadmin/homepage-howitworks' }, 'sideNavitemRTL')} onClick={() => this.openClose()}>
                          <span className={cx(s.displayInlineBlock, s.vtrTop, s.sideNavitemCollapse, 'sideNavitemCollapseTextRTL')}>
                            <img src={RightArrowIcon} className={cx(s.sideMenuIcon, s.sideNavitemCollapseIcon, 'sideNavitemCollapseIconRTL')} alt='right arrow icon' />
                          </span>
                          <span className={cx(s.displayInlineBlock, s.vtrMiddle, s.sideNavitemCollapseText)}>
                            <FormattedMessage {...messages.howItWorks} />
                          </span>
                        </Link>
                        <Link to={'/siteadmin/homepage-user'} className={cx(s.sideNavitem, s.sideNavitemCollapsePadding, { [s.activeMenu]: location === '/siteadmin/homepage-user' }, 'sideNavitemRTL')} onClick={() => this.openClose()}>
                          <span className={cx(s.displayInlineBlock, s.vtrTop, s.sideNavitemCollapse, 'sideNavitemCollapseTextRTL')}>
                            <img src={RightArrowIcon} className={cx(s.sideMenuIcon, s.sideNavitemCollapseIcon, 'sideNavitemCollapseIconRTL')} alt='right arrow icon' />
                          </span>
                          <span className={cx(s.displayInlineBlock, s.vtrMiddle, s.sideNavitemCollapseText)}>
                            <FormattedMessage {...messages.safetySectionSettings} />
                          </span>
                        </Link>
                        <Link to={'/siteadmin/homepage-driverApp'} className={cx(s.sideNavitem, s.sideNavitemCollapsePadding, { [s.activeMenu]: location === '/siteadmin/homepage-driverApp' }, 'sideNavitemRTL')} onClick={() => this.openClose()}>
                          <span className={cx(s.displayInlineBlock, s.vtrTop, s.sideNavitemCollapse, 'sideNavitemCollapseTextRTL')}>
                            <img src={RightArrowIcon} className={cx(s.sideMenuIcon, s.sideNavitemCollapseIcon, 'sideNavitemCollapseIconRTL')} alt='right arrow icon' />
                          </span>
                          <span className={cx(s.displayInlineBlock, s.vtrMiddle, s.sideNavitemCollapseText)}>
                            <FormattedMessage {...messages.signupSectionSettings} />
                          </span>
                        </Link>
                        <Link to={'/siteadmin/homepage-category'} className={cx(s.sideNavitem, s.sideNavitemCollapsePadding, { [s.activeMenu]: location === '/siteadmin/homepage-category' }, 'sideNavitemRTL')} onClick={() => this.openClose()}>
                          <span className={cx(s.displayInlineBlock, s.vtrTop, s.sideNavitemCollapse, 'sideNavitemCollapseTextRTL')}>
                            <img src={RightArrowIcon} className={cx(s.sideMenuIcon, s.sideNavitemCollapseIcon, 'sideNavitemCollapseIconRTL')} alt='right arrow icon' />
                          </span>
                          <span className={cx(s.displayInlineBlock, s.vtrMiddle, s.sideNavitemCollapseText)}>
                            <FormattedMessage {...messages.categories} />
                          </span>
                        </Link>
                        <Link to={'/siteadmin/homepage-footersettings'} className={cx(s.sideNavitem, s.sideNavitemCollapsePadding, { [s.activeMenu]: location === '/siteadmin/homepage-footersettings' }, 'sideNavitemRTL')} onClick={() => this.openClose()}>
                          <span className={cx(s.displayInlineBlock, s.vtrTop, s.sideNavitemCollapse, 'sideNavitemCollapseTextRTL')}>
                            <img src={RightArrowIcon} className={cx(s.sideMenuIcon, s.sideNavitemCollapseIcon, 'sideNavitemCollapseIconRTL')} alt='right arrow icon' />
                          </span>
                          <span className={cx(s.displayInlineBlock, s.vtrMiddle, s.sideNavitemCollapseText)}>
                            <FormattedMessage {...messages.footerSectionSettings} />
                          </span>
                        </Link>
                      </div>
                    </Collapse>
                  </div>
                }
                {validatePrivilege(2, privileges) && <div>
                  <div id='Homepage'>
                    <Button
                      variant='link'
                      className={cx(s.button, s.noPadding, s.noBorderBtn, s.btnWidth, s.sideNavitem, { [s.activeInnerMenu]: storeSettingsArray.includes(location) }, 'sideNavitemRTL')}
                      onClick={() => {
                        this.setState({
                          restuarantHomepageSettings: !this.state.restuarantHomepageSettings
                        })
                      }
                      }
                    >
                      <span className={cx(s.displayInlineBlock, s.vtrTop, s.mozWidth)}>
                        <img src={HomeSettingIcon} className={cx(s.sideMenuIcon, s.noFilter)} alt='home setting icon' />
                      </span>
                      <span className={cx(s.displayInlineBlock, s.vtrMiddle)}>
                        <FormattedMessage {...messages.restuarantHomepageSettings} />
                      </span>
                      {
                        this.state.restuarantHomepageSettings &&
                        <div className={cx(s.displayInlineBlock, s.arrowCss)}>
                          <FontAwesome.FaAngleUp className={s.navigationIcon} />
                        </div>
                      }

                      {
                        !this.state.restuarantHomepageSettings && <div className={cx(s.displayInlineBlock, s.arrowCss)}><FontAwesome.FaAngleDown className={s.navigationIcon} /></div>
                      }
                    </Button>
                  </div>
                  <Collapse in={this.state.restuarantHomepageSettings} className={s.subMenu}>
                    <div>
                      <Link to={'/siteadmin/store-home/banner'} className={cx(s.sideNavitem, s.sideNavitemCollapsePadding, { [s.activeMenu]: location === '/siteadmin/store-home/banner' }, 'sideNavitemRTL')} onClick={() => this.openClose()}>
                        <span className={cx(s.displayInlineBlock, s.vtrTop, s.sideNavitemCollapse, 'sideNavitemCollapseTextRTL')}>
                          <img src={RightArrowIcon} className={cx(s.sideMenuIcon, s.sideNavitemCollapseIcon, 'sideNavitemCollapseIconRTL')} alt='right arrow' />
                        </span>
                        <span className={cx(s.displayInlineBlock, s.vtrMiddle, s.sideNavitemCollapseText)}>
                          <FormattedMessage {...messages.bannerSection} />
                        </span>
                      </Link>
                      <Link to={'/siteadmin/store-home/info'} className={cx(s.sideNavitem, s.sideNavitemCollapsePadding, { [s.activeMenu]: location === '/siteadmin/store-home/info' }, 'sideNavitemRTL')} onClick={() => this.openClose()}>
                        <span className={cx(s.displayInlineBlock, s.vtrTop, s.sideNavitemCollapse, 'sideNavitemCollapseTextRTL')}>
                          <img src={RightArrowIcon} className={cx(s.sideMenuIcon, s.sideNavitemCollapseIcon, 'sideNavitemCollapseIconRTL')} alt='right arrow' />
                        </span>
                        <span className={cx(s.displayInlineBlock, s.vtrMiddle, s.sideNavitemCollapseText)}>
                          <FormattedMessage {...messages.infoSection} />
                        </span>
                      </Link>
                      <Link to={'/siteadmin/store-home/contact'} className={cx(s.sideNavitem, s.sideNavitemCollapsePadding, { [s.activeMenu]: location === '/siteadmin/store-home/contact' }, 'sideNavitemRTL')} onClick={() => this.openClose()}>
                        <span className={cx(s.displayInlineBlock, s.vtrTop, s.sideNavitemCollapse, 'sideNavitemCollapseTextRTL')}>
                          <img src={RightArrowIcon} className={cx(s.sideMenuIcon, s.sideNavitemCollapseIcon, 'sideNavitemCollapseIconRTL')} alt='right arrow' />
                        </span>
                        <span className={cx(s.displayInlineBlock, s.vtrMiddle, s.sideNavitemCollapseText)}>
                          <FormattedMessage {...messages.sliderContact} />
                        </span>
                      </Link>

                      <Link to={'/siteadmin/store-home/slider'} className={cx(s.sideNavitem, s.sideNavitemCollapsePadding, { [s.activeMenu]: location === '/siteadmin/store-home/slider' }, 'sideNavitemRTL')} onClick={() => this.openClose()}>
                        <span className={cx(s.displayInlineBlock, s.vtrTop, s.sideNavitemCollapse, 'sideNavitemCollapseTextRTL')}>
                          <img src={RightArrowIcon} className={cx(s.sideMenuIcon, s.sideNavitemCollapseIcon, 'sideNavitemCollapseIconRTL')} alt='right arrow' />
                        </span>
                        <span className={cx(s.displayInlineBlock, s.vtrMiddle, s.sideNavitemCollapseText)}>
                          <FormattedMessage {...messages.sliderSection} />
                        </span>
                      </Link>
                    </div>
                  </Collapse>
                </div>
                }

                {
                  isSuperAdmin && <div>
                    <div>
                      <Button
                        variant="link"
                        className={cx(s.button, s.noPadding, s.noBorderBtn, s.btnWidth, s.sideNavitem, s.btnNoPadding, (adminManagementArray.includes(location) ? [s.activeInnerMenu] : ''), 'sideNavitemRTL')}
                        onClick={() => this.setState({
                          subAdmin: !this.state.subAdmin
                        })}>
                        <span className={cx(s.displayInlineBlock, s.vtrTop)}>
                          <img src={adminIcon} className={cx(s.sideMenuIcon, s.noFilter)} alt='admin icon' />
                        </span>
                        <span className={s.displayInlineBlock}><FormattedMessage {...messages.manageAdmin} /></span>
                        {
                          this.state.subAdmin &&
                          <div className={cx(s.displayInlineBlock, s.arrowCss)}>
                            <FontAwesome.FaAngleUp className={s.navigationIcon} />
                          </div>
                        }

                        {
                          !this.state.subAdmin && <div className={cx(s.displayInlineBlock, s.arrowCss)}><FontAwesome.FaAngleDown className={s.navigationIcon} /></div>
                        }

                      </Button>
                    </div>
                    <Collapse in={this.state.subAdmin} className={s.subMenu}>
                      <div>
                        <li>
                          <Link to={'/siteadmin/admin-users'} className={cx(s.sideNavitem, s.disPlayTable, { [s.activeMenu]: location === '/siteadmin/admin-users' }, 'sideNavitemRTL')} onClick={() => this.openClose()}>
                            <span className={cx(s.displayInlineBlock, s.vtrTop, s.sideNavitemCollapse, 'sideNavitemCollapseTextRTL')}>
                              <img src={RightArrowIcon} className={cx(s.sideMenuIcon, s.sideNavitemCollapseIcon, 'sideNavitemCollapseIconRTL')} alt='right arrow' />
                            </span>
                            <span className={s.disPlayTabelCell}><FormattedMessage {...messages.manageAdminUsers} /></span>
                          </Link>
                        </li>

                        <li>
                          <Link to={'/siteadmin/admin-roles'} className={cx(s.sideNavitem, s.disPlayTable, { [s.activeMenu]: location === '/siteadmin/admin-roles' }, 'sideNavitemRTL')} onClick={() => this.openClose()}>
                            <span className={cx(s.displayInlineBlock, s.vtrTop, s.sideNavitemCollapse, 'sideNavitemCollapseTextRTL')}>
                              <img src={RightArrowIcon} className={cx(s.sideMenuIcon, s.sideNavitemCollapseIcon, 'sideNavitemCollapseIconRTL')} alt='right arrow' />
                            </span>
                            <span className={s.disPlayTabelCell}>
                              <FormattedMessage {...messages.manageAdminRoles} /></span>
                          </Link>
                        </li>
                      </div>
                    </Collapse>
                  </div>
                }


                {validatePrivilege(22, privileges) && <Link to={'/siteadmin/delivery-type'} className={cx(s.sideNavitem, { [s.activeMenu]: location.startsWith('/siteadmin/delivery-type') }, 'sideNavitemRTL')} onClick={() => this.openClose()}>
                  <span className={cx(s.displayInlineBlock, s.vtrTop)}>
                    <img src={deliveryTYpeIcon} className={s.sideMenuIcon} alt='delivery type icon' />
                  </span>
                  <span className={cx(s.displayInlineBlock, s.vtrMiddle)}>
                    <FormattedMessage {...messages.deliveryModuleMenu} />
                  </span>
                </Link>}
                {validatePrivilege(8, privileges) && <Link to={'/siteadmin/category'} className={cx(s.sideNavitem, { [s.activeMenu]: location.startsWith('/siteadmin/category') }, 'sideNavitemRTL')} onClick={() => this.openClose()}>
                  <span className={cx(s.displayInlineBlock, s.vtrTop)}>
                    <img src={CategoriesIcon} className={s.sideMenuIcon} alt='categories icon' />
                  </span>
                  <span className={cx(s.displayInlineBlock, s.vtrMiddle)}>
                    <FormattedMessage {...messages.categoryMenu} />
                  </span>
                </Link>}
                {validatePrivilege(8, privileges) && <Link to={'/siteadmin/shop-category-icon'} className={cx(s.sideNavitem, { [s.activeMenu]: location.startsWith('/siteadmin/shop-category-icon') }, 'sideNavitemRTL')} onClick={() => this.openClose()}>
                  <span className={cx(s.displayInlineBlock, s.vtrTop)}>
                    <img src={CategoriesIcon} className={s.sideMenuIcon} alt='categories icon' />
                  </span>
                  <span className={cx(s.displayInlineBlock, s.vtrMiddle)}>
                    <FormattedMessage {...messages.shopCategoryIconMenu} />
                  </span>
                </Link>}
                {validatePrivilege(24, privileges) && <Link to={'/siteadmin/location'} className={cx(s.sideNavitem, { [s.activeMenu]: location.startsWith('/siteadmin/location') }, 'sideNavitemRTL')} onClick={() => this.openClose()}>
                  <span className={cx(s.displayInlineBlock, s.vtrTop)}>
                    <FontAwesome.FaMap className={s.sideMenuIcon} alt='manage location icon' />
                  </span>
                  <span className={cx(s.displayInlineBlock, s.vtrMiddle)}>
                    <FormattedMessage {...messages.locationMenu} />
                  </span>
                </Link>}
                {validatePrivilege(23, privileges) && <Link to={'/siteadmin/payment-gateway'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', { [s.activeMenu]: location.startsWith('/siteadmin/payment-gateway') })} onClick={() => this.openClose()}>
                  <span className={cx(s.vtrTop, s.iconWidth, s.displayTableCell)}>
                    <img src={managePaymentGatewayIcon} className={s.sideMenuIcon} alt='manage payment gateway icon' />
                  </span>
                  <span className={cx(s.vtrMiddle, s.displayTableCell, 'textAlignRightRTL')}>
                    <FormattedMessage {...messages.managePaymentGateWay} />
                  </span>
                </Link>}
                <div>
                  <div id='FareAndFees'>
                    <Button
                      variant='link'
                      className={cx(s.button, s.noPadding, s.noBorderBtn, s.btnWidth, s.sideNavitem, s.btnNoPadding, { [s.activeInnerMenu]: fareAndFeesArray.some(item => location.startsWith(item)) }, 'sideNavitemRTL')}
                      onClick={() => {
                        this.setState({
                          fareAndFees: !this.state.fareAndFees
                        })
                      }
                      }
                    >
                      <span className={cx(s.displayInlineBlock, s.vtrTop, s.mozWidth)}>
                        <img src={configIcon} className={cx(s.sideMenuIcon, s.noFilter)} alt='fare and fees icon' />
                      </span>
                      <span className={cx(s.displayInlineBlock, s.vtrMiddle)}>
                        <FormattedMessage {...messages.fareAndFees} />
                      </span>
                      {
                        this.state.fareAndFees &&
                        <div className={cx(s.displayInlineBlock, s.arrowCss)}>
                          <FontAwesome.FaAngleUp className={s.navigationIcon} />
                        </div>
                      }

                      {
                        !this.state.fareAndFees && <div className={cx(s.displayInlineBlock, s.arrowCss)}><FontAwesome.FaAngleDown className={s.navigationIcon} /></div>
                      }
                    </Button>
                  </div>
                  <Collapse in={this.state.fareAndFees} className={s.subMenu}>
                    <div>
                      {validatePrivilege(7, privileges) && <Link to={'/siteadmin/manage-service-fee'} className={cx(s.sideNavitem, s.sideNavitemCollapsePadding, { [s.activeMenu]: location.startsWith('/siteadmin/manage-service-fee') }, 'sideNavitemRTL')} onClick={() => this.openClose()}>
                        <span className={cx(s.displayInlineBlock, s.vtrTop, s.sideNavitemCollapse, 'sideNavitemCollapseTextRTL')}>
                          <img src={serviceFee} className={cx(s.sideMenuIcon, s.sideNavitemCollapseIcon, 'sideNavitemCollapseIconRTL')} alt='service fee icon' />
                        </span>
                        <span className={cx(s.displayInlineBlock, s.vtrMiddle, s.sideNavitemCollapseText)}>
                          <FormattedMessage {...messages.serviceFeeMenu} />
                        </span>
                      </Link>}
                      <Link to={'/siteadmin/ride-fare'} className={cx(s.sideNavitem, s.sideNavitemCollapsePadding, { [s.activeMenu]: location.startsWith('/siteadmin/ride-fare') }, 'sideNavitemRTL')} onClick={() => this.openClose()}>
                        <span className={cx(s.displayInlineBlock, s.vtrTop, s.sideNavitemCollapse, 'sideNavitemCollapseTextRTL')}>
                          <img src={VehicleType} className={cx(s.sideMenuIcon, s.sideNavitemCollapseIcon, s.noFilter, 'sideNavitemCollapseIconRTL')} alt='ride fare icon' />
                        </span>
                        <span className={cx(s.displayInlineBlock, s.vtrMiddle, s.sideNavitemCollapseText)}>
                          <FormattedMessage {...messages.rideFareMenu} />
                        </span>
                      </Link>
                    </div>
                  </Collapse>
                </div>
                {validatePrivilege(9, privileges) && <Link to={'/siteadmin/vehicle-type/list'} className={cx(s.sideNavitem, { [s.activeMenu]: location.startsWith('/siteadmin/vehicle-type') }, 'sideNavitemRTL')} onClick={() => this.openClose()}>
                  <span className={cx(s.displayInlineBlock, s.vtrTop)}>
                    <img src={VehicleType} className={cx(s.sideMenuIcon, s.noFilter)} alt='vehicle icon' />
                  </span>
                  <span className={cx(s.displayInlineBlock, s.vtrMiddle)}>
                    <FormattedMessage {...messages.vehicleTypes} />
                  </span>
                </Link>}

                {validatePrivilege(11, privileges) && <Link to={'/siteadmin/admin-earnings'} className={cx(s.sideNavitem, { [s.activeMenu]: location.startsWith('/siteadmin/admin-earnings') || location.startsWith('/siteadmin/view-earning') }, 'sideNavitemRTL')} onClick={() => this.openClose()}>
                  <span className={cx(s.displayInlineBlock, s.vtrTop)}>
                    <img src={AdminEarningIcon} className={cx(s.sideMenuIcon, s.noFilter)} alt='admin earning icon' />
                  </span>
                  <span className={cx(s.displayInlineBlock, s.vtrMiddle)}>
                    <FormattedMessage {...messages.earningsMenu} />
                  </span>
                </Link>}

                {validatePrivilege(15, privileges) && <Link to={'/siteadmin/reviews'} className={cx(s.sideNavitem, { [s.activeMenu]: location.startsWith('/siteadmin/reviews') }, 'sideNavitemRTL')} onClick={() => this.openClose()}>
                  <span className={cx(s.displayInlineBlock, s.vtrTop)}>
                    <img src={ReviewManage} className={cx(s.sideMenuIcon, s.noFilter)} alt='review icon' />
                  </span>
                  <span className={cx(s.displayInlineBlock, s.vtrMiddle)}>
                    <FormattedMessage {...messages.ratings} />
                  </span>
                </Link>}

                {validatePrivilege(26, privileges) && <Link to={'/siteadmin/refunds'} className={cx(s.sideNavitem, { [s.activeMenu]: location.startsWith('/siteadmin/refunds') }, 'sideNavitemRTL')} onClick={() => this.openClose()}>
                  <span className={cx(s.displayInlineBlock, s.vtrTop)}>
                    <img src={ReviewManage} className={cx(s.sideMenuIcon, s.noFilter)} alt='refunds icon' />
                  </span>
                  <span className={cx(s.displayInlineBlock, s.vtrMiddle)}>
                    <FormattedMessage {...messages.manageRefunds} />
                  </span>
                </Link>}

                {validatePrivilege(17, privileges) && <Link to={'/siteadmin/change/admin'} className={cx(s.sideNavitem, { [s.activeMenu]: location == '/siteadmin/change/admin' }, 'sideNavitemRTL')} onClick={() => this.openClose()}>
                  <span className={cx(s.displayInlineBlock, s.vtrTop)}>
                    <img src={ChangePasswordIcon} className={cx(s.sideMenuIcon, s.noFilter)} alt='change password icon' />
                  </span>
                  <span className={cx(s.displayInlineBlock, s.vtrMiddle)}>
                    <FormattedMessage {...messages.changePassword} />
                  </span>
                </Link>}

                {validatePrivilege(18, privileges) && <Link to={'/siteadmin/currency'} className={cx(s.sideNavitem, { [s.activeMenu]: location == '/siteadmin/currency' }, 'sideNavitemRTL')} onClick={() => this.openClose()}>
                  <span className={cx(s.displayInlineBlock, s.vtrTop)}>
                    <img src={ManageCurrencyIcon} className={cx(s.sideMenuIcon, s.noFilter)} alt='manage currency icon' />
                  </span>
                  <span className={cx(s.displayInlineBlock, s.vtrMiddle)}>
                    <FormattedMessage {...messages.manageCurrency} />
                  </span>
                </Link>}
                {validatePrivilege(19, privileges) && <Link to={'/siteadmin/cancel-reasons'} className={cx(s.sideNavitem, { [s.activeMenu]: location.startsWith('/siteadmin/cancel-reasons') }, 'sideNavitemRTL')} onClick={() => this.openClose()}>
                  <span className={cx(s.displayInlineBlock, s.vtrTop)}>
                    <img src={CancelReason} className={cx(s.sideMenuIcon, s.noFilter)} alt='cancel reason icon' />
                  </span>
                  <span className={cx(s.displayInlineBlock, s.vtrMiddle)}>
                    <FormattedMessage {...messages.cancellationReasons} />
                  </span>
                </Link>}

                <Link to={'/'} className={cx(s.sideNavitem, s.logOutSection, 'sideNavitemRTL')} onClick={() => this.openClose()}>
                  <span className={cx(s.displayInlineBlock, s.vtrTop)}>
                    <img src={MainSiteIcon} className={cx(s.sideMenuIcon, s.noFilter)} alt='main site icon' />
                  </span>
                  <span className={cx(s.displayInlineBlock, s.vtrMiddle)}>
                    <FormattedMessage {...messages.goToMainSite} />
                  </span>
                </Link>
                <Link to={''} onClick={() => adminLogout()} className={cx(s.sideNavitem, s.logOutSection, 'sideNavitemRTL')}>
                  <span className={cx(s.displayInlineBlock, s.vtrTop)}>
                    <img src={LogOutIcon} className={cx(s.sideMenuIcon, s.noFilter)} alt='logout icon' />
                  </span>
                  <span className={cx(s.displayInlineBlock, s.vtrMiddle)}>
                    <FormattedMessage {...messages.logout} />
                  </span>
                </Link>
              </Nav>
            </div>
          </Navbar>
        </div >
      </div >
    );
  }
}

const mapState = state => ({
  currentLocale: state.intl.locale,
  isSuperAdmin: state.runtime.isSuperAdmin,
  privileges: state.account.privileges && state.account.privileges.privileges && state.account.privileges.privileges,
});

const mapDispatch = {
  adminLogout,
  openHeaderModal
};

export default withStyles(s)(connect(mapState, mapDispatch)(SideMenu));
